<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form-model :model="formData" :rules="rules" ref="ruleForm">
                <a-form-model-item label="Nomor" prop="decree_number">
                    <a-input v-model="formData.decree_number"/>
                </a-form-model-item>

                <a-form-model-item label="Tanggal" required prop="decree_date">
                    <a-date-picker
                        @change="onDateChange"
                        :format="'YYYY-MM-DD'"
                        v-model="formData.decree_date"
                        type="date"
                    />
                </a-form-model-item>

                <a-form-model-item label="Judul" prop="title">
                    <a-input v-model="formData.title"/>
                </a-form-model-item>

                <a-form-model-item label="Keterangan" prop="description">
                    <a-textarea v-model="formData.description" :rows="4" />
                </a-form-model-item>

                <a-form-model-item>
                    File SK: <a-button type="link" size="small"
                            v-if="editing"
                            @click="download(formData.attachment)">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                        </a-button><br/>
                    <a-upload
                        :file-list="fileList"
                        :remove="handleRemove"
                        :before-upload="beforeUpload"
                        @change="handleChange"
                    >
                        <a-button>
                            <a-icon type="upload" /> Select File
                        </a-button>
                    </a-upload>
                </a-form-model-item>

                <a-form-model-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="handleSubmit"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-model-item>
            </a-form-model>
        </a-skeleton>
    </a-card>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        hash: {
            type: Number,
            default: 0
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
            formData: {},
            fileList: [],
            rules: {
                decree_number: [{ required: true, message: 'Nomor SK harus diisi', trigger: 'blur' }],
                decree_date: [{ required: true, message: 'Tanggal harus diisi', trigger: 'change' }],
                title: [{ required: true, message: 'Judul harus diisi', trigger: 'blur' }],
                description: [{ required: true, message: 'Keterangan harus diisi', trigger: 'blur' }],
            }
        };
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
        }
    },
    computed: {
        editing() {
            return this.hash !== ""
        },
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri('api.project-management.sk-organization.edit', {
                        decree: this.hash
                    })
                )
                .then(res => (this.formData = res.data))
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e)

            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.processing = true

                    let promise

                    var data = new FormData()

                    for (var k in this.formData) {
                        if (this.formData.hasOwnProperty(k)) {
                            data.append(k, this.formData[k])
                        }
                    }

                    data.append("attachment", this.fileList[0])

                    if (this.editing) {
                        promise = this.$http.post(
                            this.routeUri('api.project-management.sk-organization.update', {
                                decree: this.hash
                            }),
                            data
                        );
                    } else {
                        promise = this.$http.post(
                            this.routeUri('api.project-management.sk-organization.store'),
                            data
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                    .finally(() => (this.processing = false))
                }else{
                    return false
                }
            })
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file)
            const newFileList = this.fileList.slice()
            newFileList.splice(index, 1)
            this.fileList = newFileList
            this.data = []
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file]
            return false
        },
        handleChange(info) {
            let fileList = [...info.fileList]

            if (fileList.length > 1) {
                fileList = fileList.slice(-1)

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url
                    }
                    return file
                });
                this.fileList = fileList
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
        onDateChange(date, dateString) {
            this.formData.decree_date = dateString
        },
        download(url) {
            window.open(url, '_blank')
        }
    }
}
</script>
